<lo-grandmaster #gm (finishedLoading)="addToGrandmaster($event, data)" *ngIf="data !== undefined"></lo-grandmaster>
